export enum UiVariantNames {
  CHARGING_STATION_ADD_BUTTON_ENABLED = 'enabled',
  CHARGING_STATION_FILTERS_NOT_UNKNOWN = 'not_unknown',
  CHARGING_STATION_SORT_LAST_SEEN_DESC = 'last_seen_desc',
  CONNECTOR_DETAILS_OUT_OF_ORDER_DISABLED = 'ooo_disabled',
  CONNECTOR_DETAILS_SOFT_RESET_DISABLED = 'resets_disabled',
  SECURITY_TAB_AUTH_REPORTING_ONLY = 'true'
}
